module.exports = __webpack_public_path__ + "img/Transsion.Dd5PSbkC.4a903f0d.png";